import React, { useState } from "react";
import cn from "classnames";
import { Link } from "react-router-dom";
import styles from "./control.module.sass";
import Icon from "../../../../../Icon";
import {ReactComponent as ArchiveSvg} from '../../../../../../media/images/icons/archive.svg'
import {ReactComponent as Trophy} from '../../../../../../media/images/icons/trophy.svg'
import Modal from "../../../../../Modals/ModalComponent";
import DeleteMember from '../../../DeleteMemberModal'

const Control = ({className, id, appid, archiveStatus, deleteStatus, markerName}) => {

  const [visibleModal, setVisibleModal] = useState(false)

  const actions = [
    {
      icon: "trash",
      action:  () => setVisibleModal(true),
    }
  ];

  return (
    <>
      <div className={cn(styles.control, className)}>
        {actions.map((x, index) => {
            return(
              <Link to={x.pathName} state={{id : id, appid : appid, markerName : markerName, archiveStatus : archiveStatus}} className={styles.button} key={index} onClick={x.action}>
                <Icon name={x.icon} size="20" className={styles.icon}/>
              </Link>
            )
        })}
      </div>
      <Modal visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <DeleteMember id={id} onClose={() => setVisibleModal(false)}/>
      </Modal>
    </>
  );
};

export default Control;
